import React from 'react'
import PropTypes from 'prop-types'
import ActiveVehicle from './components/ActiveVehicle'
import Vehicle from './components/Vehicle'

const VehicleSection = ({
  isActiveVehicle,
  isTrailerOrGenericTrailer,
  noOfVehicles,
  ...props
}) =>
  (isActiveVehicle || (!isActiveVehicle && isTrailerOrGenericTrailer && noOfVehicles === 1))
    ? (
      <ActiveVehicle
        isActiveVehicle={ isActiveVehicle }
        noOfVehicles={ noOfVehicles }
        { ...props } />
    )
    : (
      <Vehicle
        noOfVehicles={ noOfVehicles }
        isActiveVehicle={ isActiveVehicle }
        { ...props } />
    )

VehicleSection.propTypes = {
  isActiveVehicle: PropTypes.bool,
  isTrailerOrGenericTrailer: PropTypes.bool,
  noOfVehicles: PropTypes.bool
}

export default VehicleSection
